export default __webpack_public_path__ + "static/media/dailySummary.5f79ce95.svg";